import { render, staticRenderFns } from "./HomeProjectSection.vue?vue&type=template&id=54a3e03e"
import script from "./HomeProjectSection.vue?vue&type=script&lang=js"
export * from "./HomeProjectSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports